module.exports = __webpack_public_path__ + "img/coach-progress-awesome.90178b02.svg";